class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelector("#CartDrawer-Overlay")?.addEventListener(
      "click",
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();
  }

  // connectedCallback() {
  //   this.addTouchEvents();
  // }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    document.querySelectorAll("#cart-icon-bubble-desktop")?.forEach((link) => {
      link.setAttribute("role", "button");
      link.setAttribute("aria-haspopup", "dialog");
      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      link.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
    document.querySelectorAll("#cart-icon-bubble-drawer")?.forEach((link) => {
      link.setAttribute("role", "button");
      link.setAttribute("aria-haspopup", "dialog");
      link.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      link.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
    const cartLinks = document
      .querySelectorAll("#cart-icon-bubble")
      ?.forEach((link) => {
        link.setAttribute("role", "button");
        link.setAttribute("aria-haspopup", "dialog");
        link.addEventListener("click", (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
        link.addEventListener("keydown", (event) => {
          if (event.code.toUpperCase() === "SPACE") {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      });
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });

    // const observer = new MutationObserver((mutationsList) => {
    //   for (const mutation of mutationsList) {
    //     if (mutation.type === "childList") {
    //       this.handleCartDrawerChange(mutation);
    //     }
    //   }
    // });

    // Start observing changes in the CartDrawer element
    // observer.observe(this, { childList: true, subtree: true });

    // Initial call to handleCartDrawerChange for the first load
    // this.handleCartDrawerChange({ type: "initialLoad" });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open"),
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
      {
        id: "cart-icon-bubble-drawer",
        selector: "#cart-icon-bubble-drawer",
      },
      {
        id: "cart-icon-bubble-desktop",
        section: "cart-icon-bubble-desktop-full",
        selector: "#cart-icon-bubble-desktop",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // addTouchEvents() {
  //   const cartDrawer = document.getElementById('CartDrawer');
  //   let touchstartX = 0
  //   let touchendX = 0

  //   function checkDirection() {
  //     if (touchendX > touchstartX)  {
  //       cartDrawer.classList.remove('active');
  //       document.body.classList.remove('overflow-hidden');
  //     }
  //   }

  //   if(window.innerWidth <= 980) {
  //     cartDrawer.addEventListener('touchstart', e => {
  //       touchstartX = e.changedTouches[0].screenX
  //     })

  //     cartDrawer.addEventListener('touchend', e => {
  //       touchendX = e.changedTouches[0].screenX
  //       checkDirection()
  //     })
  //   }
  // }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble-drawer",
        section: "cart-icon-bubble-drawer",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble-desktop",
        section: "cart-icon-bubble-desktop-full",
        selector: ".cart-icon-bubble-desktop",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);

/**
 *  @class
 *  @function DrawerProductRecommendations
 */
if (!customElements.get("drawer-product-recommendations")) {
  class DrawerProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    fetchProducts() {
      // console.log("fetch")
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          // console.log("then")
          const html = document.createElement("div");
          html.innerHTML = text;
          console.log(html);
          const recommendations = html.querySelector(
            `drawer-product-recommendations[data-type=${this.dataset.type}]`,
          );

          if (recommendations && recommendations.innerHTML.trim().length) {
            // Count product items
            const productItems = recommendations.querySelectorAll(
              ".grid__item, .card-product--small",
            );
            const upsellingContainer = this.closest(".drawer__upselling");

            // Only show if at least 2 products
            if (productItems.length >= 2) {
              this.innerHTML = recommendations.innerHTML;
              if (upsellingContainer) upsellingContainer.style.display = "";
            } else {
              if (upsellingContainer) upsellingContainer.style.display = "none";
            }
            // console.log("inserted")
          } else {
            const upsellingContainer = this.closest(".drawer__upselling");
            if (upsellingContainer) upsellingContainer.style.display = "none";
          }

          this.classList.add("product-recommendations--loaded");
        })
        .catch((e) => {
          console.error(e);
        });
    }
    connectedCallback() {
      console.log("cart-drawer Connected");
      this.fetchProducts();
    }
  }
  customElements.define(
    "drawer-product-recommendations",
    DrawerProductRecommendations,
  );
}

// Mouseover Function for Quick Add Buttons of Product Card
function setSellingPlanQuickAddValue(event) {
  let product_card = event.target.closest(".product-card-wrapper");
  let selling_plan_input = product_card.querySelector(
    "input[name='selling_plan']",
  );
  let sub_is_selected = false;

  if (
    document.querySelector("cart-selling-plan-select .recurring:checked") &&
    !document.querySelector("cart-drawer.is-empty")
  ) {
    sub_is_selected = true;
  }
  if (product_card.dataset.sellingPlanIds != "" && sub_is_selected) {
    let selected_plan = document.querySelector(
      "cart-selling-plan-select .selling_plan-select",
    ).value;
    selling_plan_input.value =
      product_card.dataset.sellingPlanIds.split(",")[selected_plan];
  } else {
    selling_plan_input.value = "";
  }
}
